<template>
  <router-link
    class="sidebar-link sidebar-link-without-dropdown d-flex align-items-center"
    :class="{
      'is-inactive':!!isInactive,
      'is-active': active,
    }"
    :to="to"
  >
    <span class="sidebar-link__icon">
      <svg xmlns="http://www.w3.org/2000/svg">
        <slot name="icon" />
      </svg>
    </span>
    <span class="sidebar-link__text show-expanded pl-1">{{ text }}</span>
  </router-link>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    to: {
      type: [String,Object],
      default: null,
    },
    isInactive: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    active() {
      return (this.$route.path === this.to || this.$route.name === this.to.name) && !this.isInactive
    }
  }
}
</script>
